var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99961,
    cy: 7.99961,
    r: 6.4,
    fill: "#A1C452"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#A1C452"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42102 4.80078C7.72243 4.80078 7.18609 5.14769 6.92468 5.70808H6.89764V4.87639H5.59961V11.2008H6.91567V8.84359H6.94271C7.19961 9.38174 7.74045 9.71975 8.44355 9.71975C9.65144 9.71975 10.3996 8.79467 10.3996 7.26027C10.3996 5.72142 9.64693 4.80078 8.42102 4.80078ZM7.97933 8.67458C7.33482 8.67458 6.91116 8.12309 6.91116 7.26027C6.91116 6.40634 7.33482 5.8415 7.97933 5.8415C8.63736 5.8415 9.052 6.39745 9.052 7.26027C9.052 8.12754 8.63736 8.67458 7.97933 8.67458Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.a0dc9bc38c6aff31a96ebcaa1f04a7a8.svg";
export { ForwardRef as ReactComponent };